import { Spacing } from "@secuis/ccp-react-components";

export const PagePadding = {
    L: 40,
    M: Spacing.M,
    XS: Spacing.S,
};
